export enum CompanyTypes {
  Airline = 0,
  GHA = 1,
  Unilode = 2,
  Agent = 3,
}
